import React from "react";
import Datetime from "react-datetime";
import Context from "../../../Context";
import Select from "react-select";

export default class ReportForm extends React.Component {
  static contextType = Context;
  constructor(props) {
    super(props);
    this.state = {
      formData: {},
      fileRefs: {},
    };
  }

  componentDidMount = () => {
    this.setDefaultValues();
  };

  componentDidUpdate(prevProps) {
    if (prevProps.form.form !== this.props.form.form) {
      this.setDefaultValues();
    }
  }

  setDefaultValues = () => {
    const form = this.props.form || {};
    const fields = form.fields || [];
    let formData = {};
    fields.forEach((field) => {
      formData[field.key] = field.value;
    });
    this.setState({ formData });
  };

  onChange = (field, value) => {
    let id = field.key;
    this.setState(
      (state) => {
        let { formData } = state;
        formData[id] = value;
        return { formData };
      },
      () => {
        if (field.mutable) {
          this.props.onMutate(this.state.formData);
        }
      }
    );
  };

  fileChange = (field, e) => {
    this.onChange(field, e.target.files || null);
  };

  selectChange = (field, result) => {
    let value = null;
    if (Array.isArray(result)) {
      let arValues = [];
      result.forEach((resultItem) => arValues.push(resultItem.value));
      value = arValues;
    } else {
      value = result ? result.value : null;
    }
    this.onChange(field, value);
  };

  dateTimeChange = (field, value) => {
    if (value instanceof Object) {
      this.onChange(field, value.toDate());
    }
  };

  renderInput = (field = {}) => {
    if (!field.key) {
      return (
        <span className="text-danger">Ошибка в форме. Отсутствует ключ</span>
      );
    }

    //timestamp, uuid, string, integer, double, boolean
    if (field.type === "string") {
      return (
        <input
          className="form-control"
          type="text"
          id={field.key}
          value={this.state.formData[field.key] || ""}
          onChange={(e) => this.onChange(field, e.target.value)}
        />
      );
    }

    if (field.type === "integer") {
      return (
        <input
          className="form-control"
          min="-2147483648"
          max="2147483648"
          step="1"
          type="number"
          id={field.key}
          value={this.state.formData[field.key] || ""}
          onChange={(e) => this.onChange(field, e.target.value)}
        />
      );
    }

    if (field.type === "double") {
      return (
        <input
          className="form-control"
          step="0.01"
          type="number"
          id={field.key}
          value={this.state.formData[field.key] || ""}
          onChange={(e) => this.onChange(field, e.target.value)}
        />
      );
    }

    if (field.type === "boolean") {
      return (
        <input
          type="checkbox"
          id={field.key}
          onChange={(e) => this.onChange(field, e.target.checked)}
          checked={this.state.formData[field.key]}
        />
      );
    }

    if (field.type === "timestamp") {
      return (
        <>
          <Datetime
            value={
              this.state.formData[field.key]
                ? new Date(this.state.formData[field.key])
                : ""
            }
            onChange={(v) => this.dateTimeChange(field, v)}
          />
        </>
      );
    }

    if (field.type === "select") {
      let items = field.data || [];
      return (
        <Select
          value={this.context.api.getReferenceValue(
            this.state.formData[field.key],
            items
          )}
          onChange={(v) => this.selectChange(field, v)}
          className="from-control react-select"
          classNamePrefix="react-select-inner"
          options={items}
          placeholder={""}
          noOptionsMessage={() => ""}
          isClearable
          isMulti={field.multiple}
        />
      );
    }

    if (field.type === "file") {
      return (
        <input
          multiple={field.multiple}
          id={field.key}
          type="file"
          className="form-control"
          onChange={(v) => this.fileChange(field, v)}
        />
      );
    }
  };

  render() {
    const form = this.props.form || {};
    const fields = form.fields || [];

    return (
      <>
        {form.form && (
          <>
            {fields.map((field, idx) => {
              return (
                <div key={idx}>
                  <div className="row mb-3 align-items-center">
                    <div className="col-lg-3">{field.label}</div>
                    <div className="col">{this.renderInput(field)}</div>
                  </div>
                </div>
              );
            })}
            <div className="text-right mb-4 mt-4">
              <button
                className="btn btn-primary"
                onClick={() => this.props.onSubmit(this.state.formData)}
              >
                Сформировать отчет
              </button>
            </div>
          </>
        )}
      </>
    );
  }
}
